import { ResourcesServiceBase, WsResources } from "./wsdl/WsResources/v1.01/WsResources.ts";

export {
    type WsResources
};

export class ResourcesService extends ResourcesServiceBase {
}
